var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16732 11.167C7.16732 10.8909 7.39118 10.667 7.66732 10.667H13.334C13.6101 10.667 13.834 10.8909 13.834 11.167C13.834 11.4432 13.6101 11.667 13.334 11.667H7.66732C7.39118 11.667 7.16732 11.4432 7.16732 11.167Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66732 13.167C7.39118 13.167 7.16732 13.3909 7.16732 13.667C7.16732 13.9432 7.39118 14.167 7.66732 14.167H11.6673C11.9435 14.167 12.1673 13.9432 12.1673 13.667C12.1673 13.3909 11.9435 13.167 11.6673 13.167H7.66732Z",
    fill: "#5B5C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83398 4.16699C3.83398 2.78628 4.95327 1.66699 6.33398 1.66699H11.1318C11.7948 1.66699 12.4307 1.93038 12.8996 2.39923L16.4351 5.93476C16.9039 6.4036 17.1673 7.03949 17.1673 7.70253V15.8337C17.1673 17.2144 16.048 18.3337 14.6673 18.3337H6.33398C4.95327 18.3337 3.83398 17.2144 3.83398 15.8337V4.16699ZM14.6673 17.3337H6.33398C5.50556 17.3337 4.83398 16.6621 4.83398 15.8337V4.16699C4.83398 3.33856 5.50556 2.66699 6.33398 2.66699H11.1318C11.1716 2.66699 11.2112 2.66857 11.2506 2.6717V5.83366C11.2506 6.80016 12.0341 7.58366 13.0006 7.58366H16.1626C16.1657 7.62306 16.1673 7.66271 16.1673 7.70253V15.8337C16.1673 16.6621 15.4957 17.3337 14.6673 17.3337ZM15.6698 6.58366L12.2506 3.16446V5.83366C12.2506 6.24787 12.5864 6.58366 13.0006 6.58366H15.6698Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFile);
export default __webpack_public_path__ + "static/media/documentFile.6904fe4abe723080d22f70978e2d9c39.svg";
export { ForwardRef as ReactComponent };